module.exports = "<p>\r\n  manual-entry works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/_Components/manual-entry/manual-entry.component.html
// module id = 411
// module chunks = 1